import { alpha, positions } from "@mui/system";

const styles = (theme) => ({
  containerComponent: {
    width: "100%",
    top: 0,
    display: "flex",
    justifyContent: "center",
    height: "60px",
    position: "sticky",
    zIndex: 999,
    flexDirection: "column",
  },
  containerPaper: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: 0,
    backgroundColor: alpha(theme.palette.background.paper, 0.8),
    backdropFilter: "blur(6px)",
    gap: 2,
    padding: 2,
  },
  buttonRefresh: {
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
    minWidth: 0,
    padding: "6px",
    lineHeight: 1,
  },
  containerLocalizationProvider: {
    display: "flex",
    gap: 2,
    flexDirection: "column",
    padding: 2,
  },
  containerSelectTime: {
    width: "50%",
    maxHeight: "300px",
    overflowY: "auto",
    overflowX: "hidden",
  },
  containerTimeOption: {
    width: "100%",
    display: "flex",
    marginLeft: "10px",
    marginBottom: "5px",
  },
  conatinerButton: {
    display: "flex",
    justifyContent: "right",
  },
  menuItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  containerAutocomplete: { display: "flex", gap: 2 },
  textAutocomplete: {
    fontSize: "0.75rem", // diminui fonte geral
    "& .MuiInputBase-input": {
      padding: "6px 8px", // padding interno reduzido
      fontSize: "0.75rem", // fonte do input
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.75rem", // fonte da label
    },
  },
  dateTimePickerTextField: {
    size: "small",
    sx: {
      fontSize: "0.75rem",
      "& .MuiInputBase-input": {
        padding: "6px 8px",
        fontSize: "0.75rem",
      },
      "& .MuiInputLabel-root": {
        fontSize: "0.75rem",
      },
    },
  },
  containerTime: {
    display: "flex",
    gap: 2,
    flexDirection: "row",
    alignItems: "center",
  },
  separtorTime: {
    height: 1.5,
    width: 10,
    backgroundColor: theme.palette.primary.main,
  },
  containerValueProgress: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default styles;
